import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useTranslate } from "@refinedev/core";

import { isValidCPF } from "@modules/users/utils/isValidCPF";
import { CreateUserFormValues, createUserSchema } from "@modules/users/validations/createUserSchama";
import { useCreateUserMutation } from "@modules/users/services/mutations";

export function useUserCreateForm() {
  const translate = useTranslate();
  const { mutateAsync, isPending } = useCreateUserMutation();

  const methods = useForm<CreateUserFormValues>({
    resolver: zodResolver(createUserSchema()),
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
